module.exports = __webpack_public_path__ + "logo-CGE-01.png?84cee2ff51e8d3d82553c2bd96576cc7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/logo-CGE-01.png
// module id = 75
// module chunks = 0